import { Action } from "@eusoft/webapp-ui/components/Action";
import { MaterialIcon } from "@eusoft/webapp-ui/components/Icon";
import { context } from "../services/Context"
import "./ContextView.scss";
import { selectContextAsync } from "../actions/Common";
import { app } from "@eusoft/webapp-framework/App";
import type { IContextSelectorArgs } from "../pages/ContextSelectorPage";

interface IContextViewOptions {

}

export interface IContextInfo {

    hideContext?: boolean;

    hideBottomNav?: boolean;
}

export function ContextView(options: IContextViewOptions) {

    const state = context;

    const editContext = () => {

        const feature = app.contentHost.content?.features?.find(a => "type" in a && a.type == "WithContext");

        return selectContextAsync(feature?.data as IContextSelectorArgs ?? ({
            type: "sale-circuit",
        }));
    }
  
    return <div className="context-view" >
        <div className="main">
            <div className="sale-circuit"><MaterialIcon name="language" />{state.saleCircuit?.name}</div>
            {state.salePoint && <div className="sale-point"><MaterialIcon name="storefront" />{state.salePointName}</div>}
            {state.operator && <div className="operator"><MaterialIcon name="person" />{state.operator?.name}</div>}
        </div>
        <Action name="edit" type="local" style="icon" onExecuteAsync={editContext}>
            <MaterialIcon name="edit"/>
        </Action>
    </div>
}